import { render, staticRenderFns } from "./WidgetPartitionsWatermetersWrapper.vue?vue&type=template&id=844f1810&scoped=true&"
import script from "./WidgetPartitionsWatermetersWrapper.vue?vue&type=script&lang=js&"
export * from "./WidgetPartitionsWatermetersWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844f1810",
  null
  
)

export default component.exports